export default __webpack_public_path__ + "a756f13d2d1c9d5ba37c370ab49c8c10.png";